module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_5012.8cfc770a.png";